import type { User } from "@supabase/supabase-js";

/**
 * RevenueCat is currently configured with normalized email app user IDs.
 * PostHog should continue using the stable Supabase UUID as its distinct ID;
 * RevenueCat's email ID is stored as a property and resolved at webhook time.
 */
export function normalizeAnalyticsEmail(email?: string | null): string | null {
  const normalized = email?.trim().toLowerCase();
  return normalized || null;
}

export function getRevenueCatAppUserId(
  user: Pick<User, "email"> | null | undefined
): string | null {
  return normalizeAnalyticsEmail(user?.email);
}

export function getPostHogDistinctIdForUser(user: Pick<User, "id" | "email">): string {
  return user.id;
}
